// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3EPxO","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__14UAD"};